import type { OwnerView } from '@ralph/contracts'
import clsx from 'clsx'
import { UserRound } from 'lucide-react'
import type { GroupAvatarSize } from '@/components/groups/GroupAvatar.tsx'
import { GroupLabel } from '@/components/groups/GroupLabel.tsx'

/**
 * Who an agent or a knowledge base belongs to, drawn (PRD-26 D-19, GRP-102).
 *
 * A group owner is its avatar and its name — the shape a group has everywhere else — and a person
 * is a plain glyph and a name, so the two are told apart by shape before anybody reads. Never an
 * id; never colour alone. `to` links a group to its page, where "who maintains this" is answered
 * by the list of its managers.
 */
export const OwnerLabel = ({
  owner,
  size = 20,
  to = false,
  className
}: {
  owner: OwnerView
  size?: GroupAvatarSize
  to?: boolean
  className?: string
}) => {
  if (owner.kind === 'group') return <GroupLabel group={owner.group} size={size} to={to} className={className} />
  return (
    <span className={clsx('inline-flex min-w-0 items-center gap-1.5 align-middle', className)}>
      <span
        aria-hidden
        className="inline-flex shrink-0 items-center justify-center rounded-full border border-rule bg-card text-fg-subtle"
        style={{ width: size, height: size }}
      >
        <UserRound size={Math.round(size * 0.55)} strokeWidth={2} />
      </span>
      <span className="min-w-0 truncate">{owner.name}</span>
    </span>
  )
}
